import { GenericCampaignCreationPropertiesType } from '@ads/front-core/api'
import { CreationFileRequirement } from '../interfaces'

export const getCreationFileRequirement = (
  fileRequirements: CreationFileRequirement[],
  type: GenericCampaignCreationPropertiesType,
) => {
  return fileRequirements?.find(
    fileRequirement => fileRequirement.creationType === type,
  )
}
